import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import AccommodationRoomTile from 'components/AccommodationKit/AccommodationRoomTile'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import FlashHotelAboutRoomModalTab from './FlashHotelAboutRoomModalTab'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import TabButton from 'components/Luxkit/Tabs/TabButton'
import TabButtonsGroup from 'components/Luxkit/Tabs/TabButtonsGroup'
import FlashHotelPackageOptionsModalTab from './FlashHotelPackageOptionsModalTab'
import zIndex from 'styles/tools/z-index'
import FlashMobileStickyHeaderFilters from '../FlashMobileStickyHeaderFilters'
import ModalContent from 'components/Luxkit/Modal/ModalContent'

const StickyTabButtonsGroup = styled(TabButtonsGroup)`
  position: sticky;
  top: 0;
  z-index: ${zIndex.stickyHeader};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`
interface Props {
  room: App.PackageRoomType;
  packageOptions: Array<OfferPackageOptionView>;
  onClose: () => void;
}

function FlashHotelRoomAndPackageDetailsModal(props: Props) {
  const {
    room,
    packageOptions,
    onClose,
  } = props

  const [selectedTab, setSelectedTab] = useState<'package-options' | 'about-room'>('package-options')
  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const packageViews = packageOptionsByRoom.find(option => option.roomId === room.id)?.packageViews
  const pkg = packageViews?.[0].package

  const selectPackageOptionsTab = useCallback(() => {
    setSelectedTab('package-options')
  }, [])

  const selectAboutRoomTab = useCallback(() => {
    setSelectedTab('about-room')
  }, [])

  if (!pkg) return null

  return (<>
    <ModalHeader
      title={room.name}
      onCloseButtonClick={onClose}
    >
      <FlashMobileStickyHeaderFilters />
    </ModalHeader>
    <ModalBody>
      <AccommodationRoomTile roomPackage={pkg}>
        <AccommodationRoomTileImage
          roomPackage={pkg}
        />
      </AccommodationRoomTile>
      <StickyTabButtonsGroup fit="grow">
        <TabButton size="medium" isActive={selectedTab === 'package-options'} onClick={selectPackageOptionsTab}>
          Package options
        </TabButton>
        <TabButton size="medium" isActive={selectedTab === 'about-room'} onClick={selectAboutRoomTab}>
          About the room
        </TabButton>
      </StickyTabButtonsGroup>
      {selectedTab === 'package-options' && <FlashHotelPackageOptionsModalTab packageViews={packageViews} />}
      {selectedTab === 'about-room' && <ModalContent><FlashHotelAboutRoomModalTab pkg={pkg} /></ModalContent>}
    </ModalBody>
  </>)
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  room: state.room,
  packageOptions: getDurationPackageOptions(state, appState),
}), FlashHotelRoomAndPackageDetailsModal)
